export const CLEARING_HOUSE_BLOCKER_AUCTION_RUNNING_OR_CLOSED = 'clearingHouse.blocker.auctionRunningOrClosed';
export const CLEARING_HOUSE_BLOCKER_ASSIGNED_IN_ZONE = 'clearingHouse.blocker.assignedInZone';
export const CLEARING_HOUSE_BLOCKER_CASH_LIMIT_EXISTS = 'clearingHouse.blocker.cashLimitDefined';
export const CLEARING_HOUSE_BLOCKER_MANUAL_CASH_LIMIT_EXISTS = 'clearingHouse.blocker.manualCashLimitDefined';

export const transformClearingHouseBlockers = (t, blockerKey, clearingHouseName, clearingHouseCode) => {
    let result;
    if (blockerKey === CLEARING_HOUSE_BLOCKER_AUCTION_RUNNING_OR_CLOSED) {
        result = t('clearing-houses.blocker.auction-running-or-closed', { clearingHouseName, clearingHouseCode });
    } else if (blockerKey === CLEARING_HOUSE_BLOCKER_ASSIGNED_IN_ZONE) {
        result = t('clearing-houses.blocker.assigned-in-zone', { clearingHouseName, clearingHouseCode });
    } else if (blockerKey === CLEARING_HOUSE_BLOCKER_CASH_LIMIT_EXISTS) {
        result = t('clearing-houses.blocker.cash-limit-exists', { clearingHouseName, clearingHouseCode });
    } else if (blockerKey === CLEARING_HOUSE_BLOCKER_MANUAL_CASH_LIMIT_EXISTS) {
        result = t('clearing-houses.blocker.manual-cash-limit-exists', { clearingHouseName, clearingHouseCode });
    } else {
        throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};

export const transformClearingHouseModificationBlockers = (t, blockerKey, clearingHouseName, clearingHouseCode) => {
    let result;
    if (blockerKey === CLEARING_HOUSE_BLOCKER_AUCTION_RUNNING_OR_CLOSED) {
        result = t('clearing-houses.blocker.modification.auction-running-or-closed', { clearingHouseName, clearingHouseCode });
    } else {
        throw new Error(`Unknown modification blocker key: ${blockerKey}`);
    }
    return result;
};
